export default function ConsignmentVehicleTracking() {
    return(
        <></>
    )
}